export default {
    "exam.title": "Examen Blanc",
    "exam.locked.title": "Accès Réservé aux Membres Premium",
    "exam.locked.description": "L'examen blanc simule les conditions réelles de l'examen officiel de citoyenneté.\nDébloquez cette fonctionnalité pour tester vos connaissances sous pression.",
    "exam.locked.cta": "Devenir Premium",
    "exam.ready.title": "Prêt pour la simulation ?",
    "exam.ready.description": "Vous allez passer un examen blanc de 20 questions aléatoires couvrant tous les chapitres du guide officiel.",
    "exam.ready.stats.time": "30 Min",
    "exam.ready.stats.time_label": "Temps Limite",
    "exam.ready.stats.questions": "20 Qs",
    "exam.ready.stats.questions_label": "Questions",
    "exam.ready.stats.passing": "15/20",
    "exam.ready.stats.passing_label": "Note de Passage",
    "exam.ready.cta": "Commencer l'examen",
    "exam.active.question_count": "Question {{current}} sur {{total}}",
    "exam.active.quit": "Abandonner l'examen",
    "exam.active.submit": "Valider ma réponse",
    "exam.active.view_results": "Voir mes résultats",
    "exam.active.next": "Question suivante",
    "exam.result.win": "Félicitations !",
    "exam.result.lose": "Dommage...",
    "exam.result.score_win": "Vous avez réussi l'examen blanc !",
    "exam.result.score_lose": "Vous n'avez pas atteint la note de passage.",
    "exam.result.stats.final_score": "Score Final",
    "exam.result.stats.accuracy": "Précision",
    "exam.result.retry": "Recommencer un examen",
    "exam.result.back_home": "Retour au tableau de bord",
    "exam.abort.title": "Quitter l'examen ?",
    "exam.abort.description": "Toute votre progression sur cet examen sera perdue. Êtes-vous sûr de vouloir quitter ?",
    "exam.abort.continue": "Continuer l'examen",
    "exam.abort.quit": "Quitter quand même",
    "exam.badges.new": "Nouveau Badge Débloqué !",
    "exam.badges.subtitle": "VOTRE EFFORT EST RÉCOMPENSÉ",
    "exam.badges.close": "Continuer ma progression"
};
